import { MenuItem } from '@mui/material';
import { HeaderFilterBox, CustomSelect, CustomTextField, CustomButton } from '../../../common';

const fieldStyles = {
  ml: { xs: 0, md: 2 },
  mt: 0,
  width: { xs: '100%', sm: '48%', md: '15%' },
  mb: { xs: 1.5, md: 0 },
};

const numericFieldStyles = {
  ...fieldStyles,
  width: { xs: '38%', sm: '15%', md: '9%' },
};

const DebtDetailFilters = ({
  filter,
  plans,
  groups,
  possessorOptions,
  onFilterChange,
  onPossessorChange,
  onResetFilters,
  loadingPlans = false,
  loadingGroups = false,
}) => {
  return (
    <>
      <HeaderFilterBox>
        <CustomSelect
          label="Plan"
          labelId="debt-detail-plan-label"
          id="debt-detail-plan-select"
          name="plan"
          value={filter.plan}
          onChange={onFilterChange}
          sx={fieldStyles}
          size="medium"
          disabled={loadingPlans}
        >
          {plans.map((plan) => (
            <MenuItem key={plan.uuid} value={plan.uuid}>
              {plan.name}
            </MenuItem>
          ))}
        </CustomSelect>

        <CustomSelect
          label="Grupo"
          labelId="debt-detail-group-label"
          id="debt-detail-group-select"
          name="group"
          value={filter.group}
          onChange={onFilterChange}
          displayEmpty
          sx={fieldStyles}
          size="medium"
          disabled={loadingGroups}
        >
          <MenuItem value="">Todos</MenuItem>
          {groups.map((group) => (
            <MenuItem key={group.uuid} value={group.uuid}>
              {group.name}
            </MenuItem>
          ))}
        </CustomSelect>

        <CustomTextField
          label="Contrato"
          id="debt-detail-contract-input"
          name="contractNumber"
          value={filter.contractNumber}
          onChange={onFilterChange}
          sx={fieldStyles}
          size="medium"
          placeholder="Ej: 1234"
        />

        <CustomSelect
          label="Poseedor"
          labelId="debt-detail-possessor-label"
          id="debt-detail-possessor-select"
          name="isPossessor"
          value={filter.isPossessor}
          onChange={(event) => onPossessorChange(event.target.value)}
          displayEmpty
          sx={fieldStyles}
          size="medium"
        >
          {possessorOptions.map((option) => (
            <MenuItem key={option.value || 'all'} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </CustomSelect>

        <CustomTextField
          label="Cuotas mín."
          id="debt-detail-min-overdue"
          name="minOverdue"
          value={filter.minOverdue}
          onChange={onFilterChange}
          sx={numericFieldStyles}
          size="medium"
          type="number"
          inputProps={{ min: 0 }}
        />

        <CustomTextField
          label="Cuotas máx."
          id="debt-detail-max-overdue"
          name="maxOverdue"
          value={filter.maxOverdue}
          onChange={onFilterChange}
          sx={numericFieldStyles}
          size="medium"
          type="number"
          inputProps={{ min: 0 }}
        />

        <CustomButton variant="warning" onClick={onResetFilters} sx={{ marginLeft: 2 }}>
          Limpiar filtros
        </CustomButton>
      </HeaderFilterBox>
    </>
  );
};

export default DebtDetailFilters;
